module.exports = __webpack_public_path__ + "img/reverseStep.4dc9c5ae.png";